import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { InvoiceDetail } from './types';
import { zodInvoiceDetailSchema } from './validations';

/**
 * Fetches invoice detail for the current tenant.
 *
 * @param invoiceId - Invoice identifier.
 * @param options - Request options supplied by TanStack Query.
 * @returns Invoice detail response.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/get_invoice_invoices__invoice_id__get
 */
export async function fetchInvoiceDetail(
  invoiceId: UUID,
  options?: KyRequestOptions,
) {
  const response = await vestigasApi
    .get(ENDPOINT.INVOICE.GET_DETAIL(invoiceId), {
      ...options,
      validate: {
        isResponseSensitive: true,
        response: zodInvoiceDetailSchema,
      },
    })
    .json<InvoiceDetail>();

  return response;
}
